export default __webpack_public_path__ + "static/media/miscellaneous04.27ace6f6.png";